import React, { useState } from 'react'
import { useEffect } from 'react';
import Helmet from 'react-helmet';
import Caption from '../../components/Caption';
import PageFlip from '../../components/PageFlip';
import WorkHeader from '../../components/WorkHeader';
import Paragraph from '../../components/Paragraph';
import ProjectImage from '../../components/ProjectImage';
import riboOverview from '../../assets/images/ribo/RIBO Overview.png';
import riboHardToFind from '../../assets/images/ribo/RIBO - Hard to find info.png';
import riboUsers from '../../assets/images/ribo/RIBO - Users.png';
import riboDesign from '../../assets/images/ribo/RIBO - Design.png';
import riboComplaint from '../../assets/images/ribo/RIBO - Complaint.png';
import riboNewStructure from '../../assets/images/ribo/RIBO - New Structure.png';
import riboOriginalStructure from '../../assets/images/ribo/RIBO - Original Structure.png';
import riboHP from '../../assets/images/ribo/RIBO - HP.png';
import riboBlog from '../../assets/images/ribo/RIBO - Blog.png';
import riboContact from '../../assets/images/ribo/RIBO - Contact.png';
import riboFAQ from '../../assets/images/ribo/RIBO - FAQ.png';
import riboTeam from '../../assets/images/ribo/RIBO - Team.png';
import riboMain from '../../assets/images/ribo/RIBO - Main.png';

function RIBO() {

    const [isChecked, setIsChecked] = useState(true);
    const handleChange = () => {
        setIsChecked(!isChecked);
    };

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const carouselImages = [riboBlog, riboContact, riboFAQ, riboTeam, riboMain];

    useEffect(() => {
        document.getElementById("works").className = 'transition duration-300 flex flex-col items-center text-lightgrey navbar-links-active'
        window.scrollTo(0, 0);
    }, []);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prevIndex) => (prevIndex - 1 + carouselImages.length) % carouselImages.length);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % carouselImages.length);
        }, 5000); // Change image every 5 seconds

        return () => clearInterval(interval);
    }, [carouselImages.length]);

    const [bg, setBg] = useState('#0054A3');
    const [accent, setAccent] = useState('#F3C400');
    const [main, setMain] = useState('#F3C400');

    return (
        <div className='bg-[#000] pb-20 overflow-x-hidden'>
            <div className='flex flex-col w-full items-center gap-20 text-secondary'>
                <Helmet>
                    <title>Stephanie Zhang  ⎯  RIBO</title>
                </Helmet>
                {/* Custom Header with Title */}
                <div className='flex flex-col gap-12 items-center text-secondary'>
                    <div className='flex flex-col pt-28 pb-16 w-screen items-center justify-center gap-24' style={{ backgroundColor: `${bg}` }}>
                        <PageFlip next='Works' nextLink='/' />
                        <p className='gellisto text-[3rem] sm:text-title select-none text-white'>RIBO</p>
                    </div>
                    
                    {/* Bird's-eye view with 3 columns per row */}
                    <div className='flex flex-col gap-8 text-primary rounded-md py-8 px-8 md:px-20 items-center justify-center mx-4 md:mx-0' style={{backgroundColor: `${bg}10`}}>
                        {/* Row 1: Duration, Role, Skills */}
                        <div className='flex flex-col lg:flex-row gap-8 items-center justify-center'>
                            <div className='flex flex-col w-64 items-center justify-center'>
                                <p className='gellisto' style={{ color: `${accent}` }}>Duration</p>
                                <p className='text-center' style={{ color: '#fff' }}>Feb 2024 - May 2025</p>
                            </div>
                            <div className='flex flex-col w-64 items-center justify-center'>
                                <p className='gellisto' style={{ color: `${accent}` }}>Role</p>
                                <p className='text-center' style={{ color: '#fff' }}>UI/UX Designer</p>
                            </div>
                            <div className='flex flex-col w-64 items-center justify-center'>
                                <p className='gellisto' style={{ color: `${accent}` }}>Skills</p>
                                <p className='text-center' style={{ color: '#fff' }}>User Research, Wireframing, Prototyping, Visual Design, Usability Testing, QA Testing</p>
                            </div>
                        </div>
                        
                        {/* Row 2: Tools */}
                        <div className='flex flex-col lg:flex-row gap-8 items-center justify-center'>
                            <div className='flex flex-col w-64 items-center justify-center'>
                                <p className='gellisto' style={{ color: `${accent}` }}>Tools</p>
                                <p className='text-center' style={{ color: '#fff' }}>Figma, Adobe Illustrator, Adobe Photoshop, Miro, Google Docs, Sheets & Slides</p>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Introduction */}
                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <p className='text-lg'>The project redesigned RIBO’s Ibsite to improve access to licensing, compliance, complaint, and discipline information for brokers and the public. The challenge was balancing detailed resources with clear, consumer-friendly content while presenting a cohesive brand. The redesign also aimed to reduce staff workload and strengthen RIBO’s digital presence.


                    </p>
                </div>

                {/* Hero Image */}
                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <img src={riboOverview} alt="RIBO Overview" className='w-full rounded-lg' />
                </div>
                <Caption text='RIBO Dashboard Overview' bg={main} />

                {/* Problem and Solution */}
                <Paragraph
                    colour={main}
                    title="Here's the problem"
                    paragraph="Users needed a clear way to access licensing, compliance, and complaint information because they required accurate guidance to stay compliant or make informed decisions."/>

                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <p className='text-lg' style={{ color: `${main}` }}>I identified a set of features and priorities that could answer this problem:</p>
                    <div className='grid grid-cols-1 md:grid-cols-2'>
                        <div className='flex flex-col gap-4 p-8 md:p-12 border-t md:border-t-0 border-b md:border-r' style={{ borderColor: '#4A5568' }}>
                            <img src={riboHardToFind} alt="Difficulty finding information online" className='w-full h-64 object-cover rounded-lg' />
                            <p className='text-lg' style={{ color: `${main}` }}>Difficulty finding information online</p>
                            <p className='text-lightgrey'>Users (brokers and the public) struggle to locate licensing, compliance, and complaint information, leading to unnecessary staff inquiries.</p>
                        </div>
                        <div className='flex flex-col gap-4 p-8 md:p-12 border-b md:border-r-0' style={{ borderColor: '#4A5568' }}>
                            <img src={riboUsers} alt="Different user needs not clearly addressed" className='w-full h-64 object-cover rounded-lg' />
                            <p className='text-lg' style={{ color: `${main}` }}>Different user needs not clearly addressed</p>
                            <p className='text-lightgrey'>The site needs to serve both existing brokers (detailed guidance and regulatory resources) and the public (basic info, complaints, verifying licenses), but these audiences have different priorities.</p>
                        </div>
                        <div className='flex flex-col gap-4 p-8 md:p-12 border-b md:border-r md:border-b-0' style={{ borderColor: '#4A5568' }}>
                            <img src={riboDesign} alt="Outdated or unclear presentation" className='w-full h-64 object-cover rounded-lg' />
                            <p className='text-lg' style={{ color: `${main}` }}>Outdated or unclear presentation</p>
                            <p className='text-lightgrey'>The current site does not effectively reflect RIBO's brand or present content in a cohesive, professional manner.</p>
                        </div>
                        <div className='flex flex-col gap-4 p-8 md:p-12 border-b-0 md:border-r-0' style={{ borderColor: '#4A5568' }}>
                            <img src={riboComplaint} alt="Inefficient complaint and discipline processes online" className='w-full h-64 object-cover rounded-lg' />
                            <p className='text-lg' style={{ color: `${main}` }}>Inefficient complaint and discipline processes online</p>
                            <p className='text-lightgrey'>Information on complaints, pending hearings, and discipline decisions is not easily accessible, creating friction for users seeking transparency.</p>
                        </div>
                    </div>
                </div>

                {/* Introduction */}
                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <p className='text-lg'>I mapped out a new site structure with clear categories and navigation, organizing licensing, compliance, complaints, and discipline information for easy access by brokers and the public.
                    </p>
                </div>

                {/* Structure Comparison */}
                <div className='flex flex-col gap-8 items-center w-11/12 md:w-3/4 xl:w-1/2'>
                    <label className="relative inline-flex items-center cursor-pointer gap-5 select-none">
                        <span className="text-sm font-medium" style={{ color: `${main}` }}>Original</span>
                        <input type="checkbox" checked={isChecked} onChange={handleChange} className="sr-only peer" />
                        <div className="w-12 h-6 rounded-full transition peer peer-checked:after:translate-x-full peer-checked:after:border-lightgrey peer-checked:ring-4 after:content-[''] after:absolute after:bg-white after:border after:rounded-full after:h-6 after:w-6 after:transition-all" style={{ backgroundColor: isChecked ? main : `${main}33` }}></div>
                        <span className="text-sm font-bold" style={{ color: `${main}` }}>New</span>
                    </label>
                    <div className='flex flex-col w-full select-none'>
                        {isChecked ? <img src={riboNewStructure} alt="RIBO New Structure" className='w-full rounded-lg' /> : <img src={riboOriginalStructure} alt="RIBO Original Structure" className='w-full rounded-lg' />}
                    </div>
                    <Caption text='Site Structure Comparison' bg={main} />
                </div>

                <Paragraph
                    colour={main}
                    title="What does this new structure solve?"
                    paragraph="The new site structure improves usability by clearly separating content for each user group. Brokers have a dedicated section with detailed resources on licensing, compliance, and business processes, while the public can easily access information on RIBO’s role, verifying broker licenses, and filing complaints. This separation ensures that each audience quickly finds relevant information without confusion, creating a more intuitive and efficient experience."/>


                {/* Introduction */}
                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <p className='text-lg'>The interface emphasizes clarity, trust, and accessibility. Clean layouts and consistent typography guide users to key tasks, while a refined color palette and subtle accents convey professionalism and approachability - reflecting RIBO's role as a trusted regulator.
                    </p>
                </div>
                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <img src={riboHP} alt="RIBO Homepage" className='w-full rounded-lg' />
                </div>

                <Caption text='RIBO Homepage' bg={main} />

                {/* Visual Design Language */}
                <Paragraph
                    colour={main}
                    title="The New Look"
                    paragraph="The visual style uses a refined palette of colours to convey trust, professionalism, and stability - core qualities of a regulatory organization. Generous spacing, clear hierarchy, and consistent use of iconography create a sense of order and ease, while subtle accents and contrast add warmth without compromising authority." />


                {/* Finalizing the results */}

                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2'>
                    <p className='text-lg'>
Adopting an agile workflow allowed us to work in focused mini-sprints. Each set of designs was reviewed by the client before being handed off to the development team, ensuring alignment throughout the process. The final product balances clarity, accessibility, and professionalism.
                    </p>
                </div>

                {/* Image Carousel */}
                <div className='flex flex-col gap-8 w-full px-8 md:px-16'>
                    <div className='relative w-full min-h-[700px] flex items-center justify-center overflow-visible'>
                        {/* Left Arrow */}
                        <button
                            onClick={prevImage}
                            className='absolute left-0 z-20 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-all duration-300 flex items-center justify-center'
                            aria-label='Previous image'
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>

                        {/* Right Arrow */}
                        <button
                            onClick={nextImage}
                            className='absolute right-0 z-20 bg-black/50 hover:bg-black/70 text-white rounded-full p-3 transition-all duration-300 flex items-center justify-center'
                            aria-label='Next image'
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>

                        {carouselImages.map((image, index) => {
                            const offset = index - currentImageIndex;
                            const isActive = offset === 0;
                            const absOffset = Math.abs(offset);
                            
                            // Calculate position and opacity
                            let translateX = offset * 30; // Percentage offset for side images
                            let opacity = isActive ? 1 : Math.max(0.2, 1 - absOffset * 0.3);
                            let scale = isActive ? 1 : 0.85;
                            let zIndex = isActive ? 10 : 5 - absOffset;
                            
                            return (
                                <img
                                    key={index}
                                    src={image}
                                    alt={`RIBO Design ${index + 1}`}
                                    className='absolute rounded-lg transition-all duration-700 ease-in-out cursor-pointer'
                                    style={{
                                        transform: `translateX(${translateX}%) scale(${scale})`,
                                        opacity: opacity,
                                        zIndex: zIndex,
                                        width: '75%',
                                        height: 'auto',
                                        maxHeight: '85vh',
                                        objectFit: 'contain'
                                    }}
                                    onClick={() => setCurrentImageIndex(index)}
                                />
                            );
                        })}
                    </div>
                    {/* Carousel Indicators */}
                    <div className='flex justify-center gap-2 py-4 mt-8'>
                        {carouselImages.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentImageIndex(index)}
                                className={`rounded-full transition-all duration-300 ${
                                    index === currentImageIndex 
                                        ? 'w-8 h-2' 
                                        : 'w-2 h-2'
                                }`}
                                style={{
                                    backgroundColor: index === currentImageIndex ? main : '#9CA3AF',
                                    opacity: index === currentImageIndex ? 1 : 0.7
                                }}
                                aria-label={`Go to image ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
                <Caption text='Final Design' bg={main} />

                <div className='flex flex-col gap-4 w-11/12 md:w-3/4 xl:w-1/2 items-center'>
                    <a href='https://ribo.com' target='_blank' rel='noopener noreferrer' className='flex flex-row items-center justify-center rounded-full bg-accent py-4 px-8 gap-2 text-primary font-semibold text-button hover:text-primary'>
                        view live site
                    </a>
                </div>


                <PageFlip next='Works' nextLink='/' />
            </div>
        </div>
    );
}

export default RIBO;

